module.exports = __webpack_public_path__ + "dc0774436b35a576c577a74fb8ac6ee1.svg";